import React, { Component } from "react";
import classnames from "classnames";
import serialize from "form-serialize";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Card from '@material-ui/core/Card';
import Button from "@material-ui/core/Button";
import FormGroup from "@material-ui/core/FormGroup";
import Input from "@material-ui/core/Input";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import FormControl from "@material-ui/core/FormControl";
import imgUrl from "../../assets/images/imageUrl.js";
import TextField from "@material-ui/core/TextField";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Loader from "../loaders/loader";
import { connect } from "react-redux";
import { useHistory, withRouter, Route, Redirect, Switch, Link } from "react-router-dom";
import { withStyles, makeStyles, useTheme, withTheme } from "@material-ui/core/styles";
import ApiServices from "../../api/api";

class UserProfileQuestionnaire extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      userDetails: [],
      values: this.props.selectValue || null
    };
    this.handleChangeMultiple = this.handleChangeMultiple.bind(this)
    this.inputChangevent = this.inputChangevent.bind(this)
  }

  getQuestionType(element) {
    switch (element.type.toLowerCase()) {
      case "text":
        return this.getTextType(element);
      case "number":
        return this.getTextType(element);
      case "date":
        return this.getDateType(element);
      case "radio":
        return this.getSelectType(element);
      case "checkbox":
        return this.getMultipleeSelectType(element);
      case "freetext":
        return this.getTextType(element);
      case "dropdown":
        return this.getSelectType(element);
      default:
        return this.getTextType(element);
    }
  }


  inputChangevent(evt) {
    var val = evt.target.type == "number" ? Math.max(0, parseInt(evt.target.value)).toString().slice(0, evt.target.maxLength) : evt.target.value;
    this.setState({ values: val })
  }

  getTextType(element) {
    let name = element.question.toLowerCase()
    let maxLength = name == 'age' ? 3 : (name == 'phone number(optional)' ? 10 : 1000);
    let type = name == 'age' ? 'number' : (name == 'phone number(optional)' ? 'number' : 'text')
    return (
      <TextField
        type={type}
        inputProps={{ maxLength: maxLength }}
        value={this.state.values}
        name={element.questionId}
        onInput={(e) => {
          e.target.value = type == "number" ? Math.max(0, parseInt(e.target.value)).toString().slice(0, maxLength) : e.target.value
        }}
        onChange={this.inputChangevent}
      />
    );
  }

  getNumberType(element) {
    let name = element.question.toLowerCase()
    let maxLength = name == 'age' ? 3 : (name == 'phone number(optional)' ? 10 : 1000);
    return (
      <TextField
        type='number'
        inputProps={{ maxLength: maxLength }}
        value={this.state.values}
        name={element.questionId}
        onInput={(e) => {
          e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, maxLength)
        }}
        onChange={this.inputChangevent}
      />
    );
  }


  getDateType(element) {
    return (
      <FormControlLabel
        className="getinvolvedtextboxholder"
        name={element.questionId}
        value={this.state.values}
        control={
          <TextField type="date" name={element.questionId} />
        }
      />
    );
  }

  getSelectType(element) {
    var readonly = element.id == 141 || element.name.toLowerCase() == "township" ? true : false;
    var radiobuttons = [];
    let options = Object.keys(element.optionMap);
    return <Select
      id="demo-mutiple-name"
      disabled={readonly}
      name={element.questionId}
      value={this.state.values}
      input={<Input />}
      onChange={this.handleChangeMultiple}
    >
      {
        options.map((o) => (
          <MenuItem key={o} value={o}>
            {element.optionMap[o]}
          </MenuItem>
        ))
      }
    </Select>
  }

  handleChangeMultiple(event) {
    this.setState({ values: event.target.value })
  };

  getMultipleeSelectType(element) {
    var radiobuttons = [];
    let options = Object.keys(element.optionMap);
    return <Select
      id="demo-mutiple-name"
      name={element.questionId}
      multiple
      value={this.state.values}
      onChange={this.handleChangeMultiple}
      input={<Input />}
    >
      {
        options.map((o) => (
          <MenuItem key={o} value={o}>
            {element.optionMap[o]}
          </MenuItem>
        ))
      }
    </Select>
  }

  render() {
    return (
      <div>{this.getQuestionType(this.props.element)} </div>
    );
  }
}


const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    communityuid: storeState.communityId,
    langId: storeState.langId,
    selectedComponentObj: storeState.componentObj,
  };
};

const themeUserProfile = withTheme(UserProfileQuestionnaire);
const routeUserProfile = withRouter(themeUserProfile);
export default connect(mapStateToProps, {})(routeUserProfile);
